<template>
  <div v-if="!mediaExpired"
       class="checkin__last-call w-100 d-flex align-items-center justify-content-between">
    <div>
        <Icon name="alertTriangle" width="20" class="mr-2"/>
        {{ $t('pages.checkins.media_deleting') }}
    </div>
    <div>
      <b-button size="sm" class="" variant="outline">
        {{ $t('pages.checkins.media_deleting_btn') }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "InfoMediaAvailableList",
  props: {
    availableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    mediaExpired() {
      return new Date(this.availableTo) < new Date()
    },
  },
}
</script>


<style scoped>

</style>